import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import duration from 'dayjs/plugin/duration';

dayjs.locale('es');
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);

export default dayjs;
